import { useContext } from "react";

import { AppContext } from "../contexts/AppContext";

export function useAppData() {
  return useContext(AppContext);
}
